import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/**
 * An information panel.
 *
 * The same card as the counts above it - surface, radius, shadow and the accent stripe down the left
 * edge - so the page reads as one thing rather than as two designs stacked. The stripe is the darker
 * end of the same blue: enough to tell "what this business is" apart from "how much is in it" without
 * introducing a second colour.
 */
export const panelSx: SxProps<Theme> = {
    position: 'relative',
    height: '100%',
    p: 2.5,
    bgcolor: theme.palette.common.white,
    borderRadius: '14px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
    overflow: 'hidden',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 8px rgba(0,0,0,0.06), 0 8px 20px rgba(0,0,0,0.05)',
    },
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: 3,
        background: `linear-gradient(180deg, ${theme.palette.primary.dark}, #10224F)`,
    },
};

/** The same caption the count cards use, so both rows label themselves the same way. */
export const panelTitleSx: SxProps<Theme> = {
    fontSize: '0.68rem',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.neutral[500],
    mb: 2,
};

/** A label above its value: the pair reads top-down, which keeps long values from being truncated. */
export const fieldLabelSx: SxProps<Theme> = {
    fontSize: '0.75rem',
    color: theme.palette.neutral[400],
    mb: 0.25,
};

export const fieldValueSx: SxProps<Theme> = {
    fontSize: '0.9375rem',
    fontWeight: 500,
    color: theme.palette.neutral[800],
    wordBreak: 'break-word',
};

/** The corner control, in the position and the transparent style the terms panels already use. */
export const editBtnSx: SxProps<Theme> = {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    background: 'transparent',
};
